module.exports = {
	"admin": {
		"group_title": "Administration"
	}
};